import styled from 'styled-components';

export const NoValue = styled.span.attrs({
  children: '-',
})`
  color: var(--coolest-gray-80);
`;
